import React from "react";
import { getFieldRefInfo } from "../ExploreTab.utils";
import useConfigRefOptions from "../hooks/useConfigRefOptions.hook";
import RefCellDisplay from "./RefCellDisplay";

const ConfigRefCell = ({ field, value, isEditable }) => {
  const refInfo = getFieldRefInfo(field);
  const { labelByKey, resolveKey, isLoading, isSuccess } = useConfigRefOptions({
    scalarName: refInfo?.scalarName,
    collectionId: refInfo?.collectionId,
    queryParams: refInfo?.queryParams
  });
  // A value with no matching option once the options are loaded is a dangling ref:
  // render the cell blank rather than leaking the raw stored key - the validation
  // results supply the cell's error outline and message.
  const isUnresolved = Boolean(value) && isSuccess && !(resolveKey(value) in labelByKey);
  const resolvedValue = value && !isUnresolved ? labelByKey[resolveKey(value)] ?? value : value;
  const isResolving = Boolean(value) && isLoading;

  return (
    <RefCellDisplay
      field={field}
      resolvedValue={resolvedValue}
      isEditable={isEditable}
      isResolving={isResolving}
      isUnresolved={isUnresolved}
    />
  );
};

export default ConfigRefCell;
